import { createApp } from 'vue'
import StafetDeltagPaaHoldStepSelectTeam from './StafetDeltagPaaHoldStepSelectTeam'

const el = '.kb-component--stafet-join-a-team-step-select-team'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((StafetDeltagPaaHoldStepSelectTeamDOM) => {
            const component = createApp(StafetDeltagPaaHoldStepSelectTeam).use(Store)
            component.mount(StafetDeltagPaaHoldStepSelectTeamDOM)
        })
    }
}
